import { FormHelperText, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTextField from "../../../components/CustomTextField";
import {
  deleteVetHolidayById,
  getVetHolidaysById,
  storeVetHolidaysById,
} from "../../../redux/reducers/doctorSlice";

const initHolidayValues = {
  startDate: new Date(),
  endDate: new Date(),
  startTime: new Date(),
  endTime: new Date(),
  remark: "",
};

const HolidayOrUnavailabilityComponent = ({ title, type, vetId }) => {
  const dispatch = useDispatch();
  const [holiday, setHoliday] = useState([]);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const [holidayError, setHolidayError] = useState(false);
  const [holidayTimeErr, setHolidayTimeErr] = useState(false);
  const filteredHolidays = holidays?.filter((item) => item?.type === type);
  const [dateErr, setDateErr] = useState(false);

  useEffect(() => {
    dispatch(getVetHolidaysById(vetId));
  }, [vetId]);

  const handleChangeHoliday = (e) => {
    const { name, value } = e?.target;
    const currentHoliday = holiday?.[0] || {};
    const reqObj = { ...currentHoliday, [name]: value };

    // Handle Date Changes
    if (name === "startDate" || name === "endDate") {
      const startDate = new Date(reqObj.startDate || currentHoliday.startDate);
      const endDate = new Date(reqObj.endDate || currentHoliday.endDate);

      // Auto-adjust endDate if startDate is after current endDate
      if (name === "startDate" && startDate > endDate) {
        reqObj.endDate = value;
      }

      setDateErr(startDate > endDate);
    }

    // Handle Time Changes
    if (name === "startTime" || name === "endTime") {
      const startTime =
        name === "startTime"
          ? new Date(reqObj.startTime)
          : new Date(currentHoliday?.startTime);
      const endTime =
        name === "endTime"
          ? new Date(reqObj.endTime)
          : new Date(currentHoliday?.endTime);

      // Check if start time is after end time (including overnight cases)
      const isInvalid =
        moment(startTime).isAfter(moment(endTime)) &&
        !moment(startTime).isSame(moment(endTime));
      setHolidayTimeErr(isInvalid);
    }

    // Handle Remark Validation
    if (name === "remark") {
      setHolidayError(!value?.trim());
    }

    setHoliday([reqObj]);
  };

  const handleAddHoliday = () => {
    setHolidayError(false);
    setDateErr(false);
    if (holiday?.length === 0) {
      setHoliday([initHolidayValues]);
    }
  };

  const handleSaveHoliday = () => {
    const reqHol = holiday?.[0];
    if (
      dateErr ||
      holidayTimeErr ||
      reqHol?.remark?.length === 0 ||
      !reqHol?.remark
    ) {
      if (dateErr) setDateErr(true);
      return setHolidayError(true);
    }
    const data = {
      holliday: reqHol?.remark,
      date: moment(new Date(reqHol?.startDate)).format("YYYY-MM-DD"),
    };
    if (type === "holliday") {
      data.endDate = moment(new Date(reqHol?.endDate)).format("YYYY-MM-DD");
      data.type = "holliday";
    } else {
      data.endDate = moment(new Date(reqHol?.startDate)).format("YYYY-MM-DD");
      data.startTime = moment(new Date(reqHol?.startTime)).format("HH:mm");
      data.endTime = moment(new Date(reqHol?.endTime)).format("HH:mm");
      data.type = "unavailability";
    }
    dispatch(storeVetHolidaysById({ vetId, data })).then((res) => {
      if (res?.payload) {
        setHoliday([]);
        setHolidayTimeErr(false);
        setDateErr(false);
        dispatch(getVetHolidaysById(vetId));
      }
    });
  };

  const handleDelHoliday = (holId) => {
    dispatch(deleteVetHolidayById(holId)).then((res) => {
      if (res?.payload) dispatch(getVetHolidaysById(vetId));
    });
  };

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div className={`flex-row mt30`}>
          <Typography className="txt-semi-bold fs14">{title}</Typography>
          <img
            src={require("../../../assets/images/png/PlusIcon.png")}
            alt=""
            className="h20 cursor ml10"
            onClick={handleAddHoliday}
          />
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div className="flex-row mt20">
          {type === "unavailability" ? (
            <>
              <div className="w20Per ph5">
                <Typography className="font-bold fs14 blue-color">
                  Date
                </Typography>
              </div>
              <div className="w20Per ph5">
                <Typography className="font-bold fs14 blue-color">
                  Start Time
                </Typography>
              </div>
              <div className="w20Per ph5">
                <Typography className="font-bold fs14 blue-color">
                  End Time
                </Typography>
              </div>
            </>
          ) : (
            <>
              <div className="w20Per ph5">
                <Typography className="font-bold fs14 blue-color">
                  Start Date
                </Typography>
              </div>
              <div className="w20Per ph5">
                <Typography className="font-bold fs14 blue-color">
                  End Date
                </Typography>
              </div>
            </>
          )}
          <div className="w30Per ph5">
            <Typography className="font-bold fs14 blue-color">
              Remarks
            </Typography>
          </div>
        </div>
        <div className="box-hor-split mt5" />
      </Grid>
      {filteredHolidays?.map((hol) => (
        <Grid item xs={12} key={hol?.holliId}>
          <div className="flex-row-ali-cen p10">
            <div className="w20Per ph5">
              <Typography className="txt-regular fs14 black">
                {moment(hol?.date).format("DD MMMM")}
              </Typography>
            </div>
            {type === "unavailability" ? (
              <>
                <div className="w20Per ph5">
                  <Typography className="txt-regular fs14 black">
                    {hol?.startTime?.slice(0, 5)}
                  </Typography>
                </div>
                <div className="w20Per ph5">
                  <Typography className="txt-regular fs14 black">
                    {hol?.endTime?.slice(0, 5)}
                  </Typography>
                </div>
              </>
            ) : (
              <div className="w20Per ph5">
                <Typography className="txt-regular fs14 black">
                  {moment(hol?.endDate).format("DD MMMM")}
                </Typography>
              </div>
            )}
            <div className="w30Per ph5">
              <Typography className="txt-regular fs14 black">
                {hol?.holliday}
              </Typography>
            </div>
            <div className="w5Per flex-center">
              <img
                src={require("../../../assets/images/png/delete.png")}
                alt=""
                className="h30 cursor"
                onClick={() => handleDelHoliday(hol?.holliId)}
              />
            </div>
          </div>
          <div className="box-hor-split w80Per" />
        </Grid>
      ))}
      {holiday?.map((hol, idx) => (
        <Grid item xs={12} key={idx}>
          <div className="flex-row p10">
            <div className="w20Per pr10">
              <CustomTextField
                name="startDate"
                fullWidth
                mobileDate
                handleChange={handleChangeHoliday}
                value={hol?.startDate}
              />
            </div>
            {type === "unavailability" ? (
              <>
                <div className="w20Per pr10">
                  <CustomTextField
                    name="startTime"
                    fullWidth
                    mobileTime
                    handleChange={handleChangeHoliday}
                    value={hol?.startTime}
                    is12HourFomat={false}
                  />
                </div>
                <div className="w20Per pr10">
                  <CustomTextField
                    name="endTime"
                    fullWidth
                    mobileTime
                    handleChange={handleChangeHoliday}
                    value={hol?.endTime}
                    is12HourFomat={false}
                  />
                </div>
              </>
            ) : (
              <div className="w20Per pr10">
                <CustomTextField
                  name="endDate"
                  fullWidth
                  mobileDate
                  handleChange={handleChangeHoliday}
                  value={hol?.endDate}
                  minDate={hol?.startDate}
                />
              </div>
            )}
            <div className="w30Per pr10">
              <CustomTextField
                name="remark"
                fullWidth
                handleChange={handleChangeHoliday}
                value={hol?.remark}
                error={holidayError}
                helperText={holidayError ? "Remark is required field" : ""}
              />
            </div>
            <div className="w5Per flex-center h40">
              <img
                src={require("../../../assets/images/png/save.png")}
                alt=""
                className="h30 cursor"
                onClick={handleSaveHoliday}
              />
            </div>
          </div>
          <div className="box-hor-split" />
          {dateErr && (
            <FormHelperText error>
              Holiday End date should be equal to or greater than start date
            </FormHelperText>
          )}
          {holidayTimeErr && (
            <FormHelperText error>
              Please provide valid time. End Time should be greater than the
              Start Time
            </FormHelperText>
          )}
        </Grid>
      ))}

      {filteredHolidays?.length === 0 &&
        (!filteredHolidays || filteredHolidays.length === 0) && (
          <div className="no-rec h100">No records available</div>
        )}
    </>
  );
};

export default HolidayOrUnavailabilityComponent;
